export default "__VITE_ASSET__gIYfhWYX__"